"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  utm_campaign: null,
  utm_medium: null,
  utm_source: null,
  meeting_funnel: null,
  meeting_product: null,
  meeting_medium: null,
  meeting_type: null,
  meeting_source: null,
  meeting_campaign: null,
  source_app: null
};

var TrackingParams = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(TrackingParams, _Record);

  function TrackingParams() {
    (0, _classCallCheck2.default)(this, TrackingParams);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrackingParams).apply(this, arguments));
  }

  (0, _createClass2.default)(TrackingParams, [{
    key: "compact",
    value: function compact() {
      return this.reduce(function (truthyFields, fieldValue, fieldName) {
        if (fieldValue) {
          truthyFields[fieldName] = fieldValue;
        }

        return truthyFields;
      }, {});
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new TrackingParams(json);
    }
  }]);
  return TrackingParams;
}((0, _immutable.Record)(defaults));

exports.default = TrackingParams;
module.exports = exports.default;